import dynamic from "next/dynamic";

export const Tagline = dynamic(() => import("./component"));
